<template>
  <v-card class="w-full pa-2 mb-4 mx-4">
    <div class="d-flex flex-row justify-between" style="place-items: center;">
      <div>
        <span 
          v-if="[3, 4, 9, 10].includes(fareType)" 
          class="f-bold f-s-xs" 
          style="color: #000;"
        >{{ $t("TicketMultiTrip") }}</span>
        <span 
          v-else
          class="f-bold f-s-xs" 
          style="color: #000;"
        >{{ data.fare_name }}</span>
      </div>
      <div class="d-flex flex-column" style="font-size: x-small;">
        <span>{{ $t("UsedDate") }}:</span>
        <span>{{ usedDate }}</span>
      </div>
    </div>
    <hr />

    <div 
      v-if="[3, 4, 9, 10].includes(fareType)" 
      class="d-flex flex-column mt-2"
    >
      <span class="f-bold f-s-xs">{{ data.fare_name }}</span>
      <span 
        v-if="$i18n.locale == 'vi' && data.max_trip == ''"
        class="f-s-xs"
      >Chuyến đi không giới hạn</span>
      <span 
        v-else-if="$i18n.locale == 'en' && data.max_trip == ''"
        class="f-s-xs"
      >Unlimited Trips</span>
      <span 
        v-else-if="$i18n.locale == 'vi' && data.max_trip != ''"
        class="f-s-xs"
      >Tập {{ data.max_trip }} vé</span>
      <span 
        v-else
        class="f-s-xs"
      >{{ data.max_trip + ' ' + $t("Kali Perjalanan")}}</span>
      <hr style="margin-bottom: 8px;" />

      <div style="place-self: flex-end;">
        <ac-button 
          :small="true"
          :name="$t('DetailTicket')" 
          :on-click-handler="clickDetail"
          :width="'80px'"
          :color="$partnerACL.getButtonColor()"
          :style="`color:${$partnerACL.getButtonColor()}`"
        />
      </div>
    </div>
    <div 
      v-else
      class="d-flex flex-row justify-between"
    >
      <timeline-dashed :route="timelineDashed"/>
      <div style="justify-items: flex-end;">
        <div style="height: 60px;"></div>
        <v-col class="d-flex justify-center pa-0" style="align-items: center; height: 40px;">
          <div style="height: 20px;">
            <ac-button 
              :small="true"
              :name="$t('ViewTicket')" 
              :on-click-handler="clickDetail"
              :width="'80px'"
              :color="$partnerACL.getButtonColor()"
              :style="`color:${$partnerACL.getButtonColor()}`"
            />
          </div>
        </v-col>
      </div>
    </div>
  </v-card>
</template>

<script>
import TimelineDashed from "@/components/TimelineDashed.vue";
import AcButton from "@/components/AcButton";
import moment from "moment"

export default {
  name: "CardMyTrip",
  components: {
    TimelineDashed,
    AcButton
  },
  props: ["data", "fareType", "expiredNote", "price"],
  data() {
    return {
      localCurrency: localStorage.getItem('currency') || 'USD'
    }
  },
  computed: {
    timelineDashed() {
      if ([3, 4, 9, 10].includes(this.fareType)) {
        return null
      }
      return {
        origin: this.data.orig_loc,
        long_origin: this.data.original_loc,
        destination: this.data.dest_loc,
        long_destination: this.data.destination_loc
      }
    },
    usedDate() {
      return moment.utc(this.data.used_date).format("DD-MM-YYYY | HH:mm")
    }
  },
  methods: {
    clickDetail() {
      const detail = {
        routename: this.data.fare_name,
        original: this.data.orig_loc,
        originalName: this.data.original_loc,
        destination: this.data.dest_loc,
        destinationName: this.data.destination_loc,
        date: moment.utc(this.data.used_date).format("DD-MM-YYYY | HH:mm"),
        ticket: this.data.ticket_id,
        description: "",
        max_trip: this.data.max_trip,
        max_trip_perday: this.data.max_trip_perday,
        used_date: this.usedDate,
        fare_name: this.data.fare_name,
        fare_rule: this.data.fare_rule,
        expired_note: this.expiredNote,
        departureTime: "",
        busName: "",
        driverName: "",
        routeCode: "",
        fare_type: Number(this.data.fare_type),
        price: this.price,
        currency_code: this.localCurrency,
        fleet_type_detail: this.data.fleet_type_detail,
        timeline_dashed: this.timelineDashed
      }

      const detailButton = this.$partnerACL.getMetaButton('detail');
      if (detailButton) {
        if (detailButton.menu_type == "wsc_menu") {
          this.$router.push({
            name: detailButton.redirect_name,
            params: {
              detail: detail
            }
          })
        } else {
          window.location = detailButton.redirect_path;
        }
      } else {
        this.$router.push({
          name: "MyTripInDetail",
          params: {
            detail: detail
          }
        })
      }
    }
  },
}
</script>

<style>
hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin: 4px 0;
}
</style>